import { cn } from '../../../utils/string/cn.utils';

const ButtonTertiarySmall = ({
  title,
  preIcon,
  posIcon,
  type = 'button',
  active = false,
  ...props
}) => {
  return (
    <button
      type={type}
      {...props}
      className={cn(
        'bg-trans hover:bg-primary-primaryFill disabled:cursor-not-allowed disabled:pointer-events-none outline-none border-none inline-flex justify-center items-center cursor-pointer',
        active ? 'bg-primary-primaryFill' : '',
        'text-body-medium font-semibold text-primary-primary disabled:text-black-low',
        'h-[24px] py-[4px] px-[8px] gap-[4px] rounded-[6px]',
        props?.className
      )}
      style={{
        ...(props?.style ?? {}),
        ...{
          paddingRight: `${preIcon ? '6px' : undefined}`,
          paddingLeft: `${posIcon ? '6px' : undefined}`,
        },
      }}
    >
      {posIcon && (
        <div className="w-[14px] h-[14px] flex justify-center items-center min-h-[14px] disabled:text-black-low">
          {posIcon}
        </div>
      )}
      <span className="truncate flex items-center justify-center disabled:text-black-low">
        {title}
      </span>
      {preIcon && (
        <div className="w-[14px] h-[14px] flex justify-center items-center min-h-[14px] disabled:text-black-low">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonTertiarySmall;
